import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { lighten } from 'polished';
import styled, { withTheme, css } from 'styled-components';
import { get } from 'lodash';

const Container = styled.div`
  align-items: ${({ alignLeft }) => (alignLeft ? 'flex-start' : 'flex-end')};;
  display: flex;
  flex-direction: column;
`;

const Button = styled.button`
  background: none;
  border: none;
  cursor: ${({ isButton }) => (isButton ? 'pointer' : 'unset')};
  margin: 0;
  outline: 0;
  text-decoration: none;

  ${({ disabled }) =>
    disabled &&
    css`
      cursor: not-allowed;
    `}
`;

const IconButton = ({
  alignLeft,
  altText,
  color,
  Icon,
  iconTitle,
  id,
  onClick,
  size,
  theme,
  dataCy,
  isButton,
  disabled,
}) => {
  let iconColor = !color ? get(theme, 'iconColor') : color;
  if (disabled) {
    iconColor = lighten(0.25, iconColor);
  }

  return (
    <FormattedMessage id={iconTitle}>
      {msg => (
        <Container alignLeft={alignLeft}>
          <Button
            disabled={disabled}
            data-cy={dataCy}
            onClick={() => onClick(id)}
            isButton={isButton}
          >
            <Icon
              size={size}
              altText={altText || msg}
              color={iconColor}
              iconTitle={msg}
              title={msg}
              disabled={disabled}
            />
          </Button>
        </Container>
      )}
    </FormattedMessage>
  );
};

IconButton.propTypes = {
  alignLeft: PropTypes.bool,
  altText: PropTypes.string,
  color: PropTypes.string,
  dataCy: PropTypes.string,
  disabled: PropTypes.bool,
  Icon: PropTypes.oneOfType([PropTypes.object, PropTypes.func]).isRequired,
  iconTitle: PropTypes.string,
  id: PropTypes.string,
  isButton: PropTypes.bool,
  onClick: PropTypes.func,
  size: PropTypes.number,
  theme: PropTypes.object.isRequired,
};

IconButton.defaultProps = {
  alignLeft: false,
  altText: 'Button',
  color: '',
  dataCy: null,
  disabled: false,
  iconTitle: 'Icon',
  id: '',
  isButton: true,
  onClick: () => null,
  size: 25,
};

export default withTheme(IconButton);
